import { Container } from 'inversify';
import { LocalCursorBundle } from '../@resources/cursors/LocalCursorBundle';
import { GoogleFontBundle } from '../@resources/fonts/GoogleFontBundle';
import { LocalFontBundle } from '../@resources/fonts/LocalFontBundle';
import { LocalIconBundle } from '../@resources/icons/LocalIconBundle';
import { StreamlineIconBundle } from '../@resources/icons/StreamlineIconBundle';
import { LocalSoundBundle } from '../@resources/sounds/LocalSoundBundle';
import { ApiClient } from '../api/ApiClient';
import { MockApiClient } from '../api/MockApiClient';
import { AssetBundle } from '../platform/assets/AssetBundle';
import { AccountModel } from './account/AccountModel';
import { KioskUser } from './canvas/kiosk/KioskUser';
import { HelpController } from './core/help/HelpController';
import { Hangout } from './hangouts/Hangout';
import { NullHangout } from './hangouts/NullHangout';
import { MetricsHub } from './MetricsHub';
import { PreferencesModel } from './preferences/PreferencesModel';
import { ProfileModel } from './ProfileModel';
import { createScope } from './Scope';

const installAppLevelModels = async (scope: Container) => {

    scope.bind(ApiClient).to(MockApiClient);

    scope.bind(AccountModel).toConstantValue(AccountModel.from({
        account: {
            id: 'AC00000KIOSK',
            podId: null as string,
            label: 'Kiosk Account',
            imageUrl: null,
            plan: {
                name: 'none',
                label: 'None',
                features: {
                    'export': true,
                    'jiraBeta': true,
                    'guestLimit': 2,
                    'workspaces': true,
                    'singleSignOn': true,
                    'accessControl': true,
                    'quantityMetric': 'user',
                    'meetingControls': true
                },
                quantity: 1,
            },
            settings: {
                'dashboard.version': 'next',
                'billing.version': 'next'
            },
            trial: null,
            metadata: {} as Record<string, any>,
            createdAt: new Date(),
        },
        workspaces: [],
    }));

    scope.bind(ProfileModel).toConstantValue(ProfileModel.from(KioskUser.me));

    scope.bind(PreferencesModel).toConstantValue(new PreferencesModel());


    // const api = scope.get(ApiClient);
    // const evts = scope.get(AppEvents);

    // // Do this before the other calls because it will prevent multiple request_access
    // const [profile, refreshProfile] = await ProfileModel.load(() => api.exec(v2.me.info()));
    // const [preferences, refreshPreferences] = await PreferencesModel.load(() => api.exec(v2.me.preferences.info()));
    // const [account, refreshAccount] = await AccountModel.load(() => api.exec(v2.me.home()));
    // const passport = PassportModel.create(await api.exec(v2.me.permissions()));

    // const boardLimit = account.active && !!account.plan.features.boardLimit && profile.id !== 'US000000ANON'
    //     ? BoardUsageModel.create(await api.exec(v2.me.boardUsage()))
    //     : BoardUsageModel.create();

    // scope.bind(AccountModel).toConstantValue(account);
    // scope.bind(BoardUsageModel).toConstantValue(boardLimit);
    // scope.bind(PreferencesModel).toConstantValue(preferences);
    // scope.bind(ProfileModel).toConstantValue(profile);
    // scope.bind(PassportModel).toConstantValue(passport);
    // scope.bind(TourManager).toSelf().inSingletonScope();
    // scope.bind(PreferencesManager).toSelf().inSingletonScope();
    scope.bind(HelpController).toSelf().inSingletonScope();

    // // TODO:
    // // This is lazy and kinda kak; should navigation have it's own sub scope?
    // // Yes it fucking should this is getting worse

    scope.bind(MetricsHub).toSelf().inSingletonScope();
    // const metrics = scope.get(MetricsHub);
    // await metrics.start();

    return Promise.resolve([
        // metrics,
        // evts.on('account:patch', (data) => {
        //     refreshAccount();
        // }),
        // evts.on('workspace:patch', ({ workspace }) => {
        //     refreshAccount();
        // }),
        // // If local user added to or removed from workspace, update home
        // evts.on('workspace:members:add', ({ user }) => {
        //     if (profile.id === user.id) refreshAccount();
        // }),
        // evts.on('workspace:members:remove', ({ userId }) => {
        //     if (profile.id === userId) refreshAccount();
        // }),
        // evts.on('workspace:create', () => {
        //     refreshAccount();
        // }),
        // evts.on('workspace:delete', () => {
        //     refreshAccount();
        // }),
        // evts.on('folder:create', ({ folder }) => {
        //     if (!account.workspaces.flatMap(x => x.folders).find(x => x.id === folder.id)) refreshAccount();
        // }),
        // evts.on('folder:patch', ({ folder }) => {
        //     if (!!account.workspaces.flatMap(x => x.folders).find(x => x.id === folder.id)) refreshAccount();
        // }),
        // evts.on('folder:delete', ({ folderId }) => {
        //     if (!!account.workspaces.flatMap(x => x.folders).find(x => x.id === folderId)) refreshAccount();
        // }),
        // evts.on('board:create', ({ board }) => {
        //     // Temporarily add board active boards (bit of a hack)
        //     if (boardLimit.limit > 0) {
        //         boardLimit.mutate(x => x.boards.push(board));
        //     }
        // }),
        // // If self user patched, update model
        // evts.on('user:patch', ({ userId }) => {
        //     if (userId === profile.id) {
        //         refreshProfile();
        //         refreshPreferences();
        //     }
        // }),
    ]);
};

const loadIntegrations = async (scope: Container) => {

    // const account = scope.get(AccountModel);
    // const profile = scope.get(ProfileModel);

    // if (account.active && (account.metadata?.intercom ?? true)) {
    //     IntercomCtrl.init(profile);
    // }

    // AnnounceKit.init();

    return Promise.resolve([]);
};

const loadStaticData = async (scope: Container) => {

    await AssetBundle.loadAll(
        new GoogleFontBundle(),
        new LocalCursorBundle(),
        new LocalFontBundle(),
        new LocalIconBundle(),
        new LocalSoundBundle(),
        new StreamlineIconBundle(),
    );

    return [];
};

const loadHangout = async (scope: Container) => {

    scope.bind(Hangout).toConstantValue(new NullHangout());

    return Promise.resolve([
    ]);
};

export const KioskAppScope = createScope({
    traceAs: 'KioskAppScope',
    refresh: async (p, scope) => {
        return [

            // Top level models
            ...(await installAppLevelModels(scope)),

            // Integrations
            ...(await loadIntegrations(scope)),

            // Static data
            ...(await loadStaticData(scope)),

            // Hangout
            ...(await loadHangout(scope)),

        ];
    },
});
